/**
 * Border-radius tokens.
 *
 * Radius encodes object class:
 *   sm   inline chips inside text
 *   md   controls and inputs
 *   lg   cards and rows
 *   xl   dialogs and sheets
 *   pill badges, chips, segmented controls
 *
 * `full` is an alias of `pill`.
 */
export const radius = {
    none: "0",
    sm: "6px",
    md: "10px",
    lg: "12px",
    xl: "16px",
    pill: "9999px",
    full: "9999px",
} as const;

export type RadiusTokens = typeof radius;
export type RadiusKey = keyof RadiusTokens;
